var ar = {};
module["exports"] = ar;
ar.title = "Arabic";
ar.separator = " & ";
ar.address = require("./address");
ar.name = require("./name");
ar.phone_number = require("./phone_number");
ar.cell_phone = require("./cell_phone");
ar.commerce = require("./commerce");
ar.vehicle = require("./vehicle");
ar.team = require("./team");
ar.date = require("./date");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/index.js
// module id = 2370
// module chunks = 1610